export const ART_PIECES = [
  {
    title: "无名",
    imgPath:
      "https://api.godliuyang.wang/v1/storage/buckets/arts/files/693424f50026fe3d81c3/view?project=693421cb0038ddff8dd1&mode=admin",
  },
  {
    title: "碎神",
    imgPath:
      "https://api.godliuyang.wang/v1/storage/buckets/arts/files/6934251b0028f2dff6f9/view?project=693421cb0038ddff8dd1&mode=admin",
  },
  {
    title: "图书馆一角",
    imgPath:
      "https://api.godliuyang.wang/v1/storage/buckets/arts/files/69342524001081224df0/view?project=693421cb0038ddff8dd1&mode=admin",
  },
  {
    title: "九灵狐狐",
    imgPath:
      "https://api.godliuyang.wang/v1/storage/buckets/arts/files/69342530001a76f06b74/view?project=693421cb0038ddff8dd1&mode=admin",
  },
  {
    title: "血河修勾",
    imgPath:
      "https://api.godliuyang.wang/v1/storage/buckets/arts/files/6934252a00050db5fea5/view?project=693421cb0038ddff8dd1&mode=admin",
  },
  {
    title: "血相",
    imgPath:
      "https://api.godliuyang.wang/v1/storage/buckets/arts/files/69342536003a75082b77/view?project=693421cb0038ddff8dd1&mode=admin",
  },
  {
    title: "剑胆琴心",
    imgPath:
      "https://api.godliuyang.wang/v1/storage/buckets/arts/files/69342541001455aef059/view?project=693421cb0038ddff8dd1&mode=admin",
  },
  {
    title: "蓝天白云下的碎梦",
    imgPath:
      "https://api.godliuyang.wang/v1/storage/buckets/arts/files/69342547002083eee1df/view?project=693421cb0038ddff8dd1&mode=admin",
  },
  {
    title: "神相",
    imgPath:
      "https://api.godliuyang.wang/v1/storage/buckets/arts/files/69342550001caf9618a9/view?project=693421cb0038ddff8dd1&mode=admin",
  },
  {
    title: "夏天与神相猫猫",
    imgPath:
      "https://api.godliuyang.wang/v1/storage/buckets/arts/files/69342557001fdcc8c446/view?project=693421cb0038ddff8dd1&mode=admin",
  },
  {
    title: "流光花与碎梦",
    imgPath:
      "https://api.godliuyang.wang/v1/storage/buckets/arts/files/6934256b0038dca49e99/view?project=693421cb0038ddff8dd1&mode=admin",
  },
  {
    title: "碎梦豹豹",
    imgPath:
      "https://api.godliuyang.wang/v1/storage/buckets/arts/files/6934257100388bacc046/view?project=693421cb0038ddff8dd1&mode=admin",
  },
  {
    title: "神相是猫猫的证据",
    imgPath:
      "https://api.godliuyang.wang/v1/storage/buckets/arts/files/69342577001aee229a1d/view?project=693421cb0038ddff8dd1&mode=admin",
  },
  {
    title: "猫狗双全",
    imgPath:
      "https://api.godliuyang.wang/v1/storage/buckets/arts/files/693429b000196dc8b49a/view?project=693421cb0038ddff8dd1&mode=admin",
  },
  // ,{
  //   title: "无名",
  //   imgPath: "https://api.godliuyang.wang/v1/storage/buckets/arts/files/693429b6001dfeee6094/view?project=693421cb0038ddff8dd1&mode=admin",
  // },
];
